module.exports = __webpack_public_path__ + "img/icon-download.c756d6a0.svg";